<script setup>
import { computed } from 'vue'

const props = defineProps({
    options: {
      type: Object,
      default: {
        size: 50
      }
    }
  });

  const ringSizePx = computed(() => props.options?.size - 8 + 'px');

  const ringBorderPx = computed(() => {
    const size = props.options?.size || 10; // ensure size is defined
    const minSize = 10;
    const maxSize = 80;
    const minBorder = 2;
    const maxBorder = 5;

    // Clamp the size value within the min and max bounds
    const clampedSize = Math.min(Math.max(size, minSize), maxSize);

    // Linear interpolation between min and max border values
    const border = minBorder + ((clampedSize - minSize) * (maxBorder - minBorder)) / (maxSize - minSize);

    return `${border}px`;
  });
</script>
<template>
  <div
    class="v-loader-ring"
    :style="{
      width: props.options?.size + 'px',
      height: props.options?.size + 'px'
    }"
  >
    <div class="lds-ring">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</template>
<style scoped>
    .v-loader-ring {
        /* top: 50%;
  left: 50%;
  position: relative;
  width: 0px;
  height: 0px; */
    }

    [fixed] {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0);
    }
    .lds-ring {
        /* display: inline-block; */
        position: relative;
    }
    .lds-ring div {
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: v-bind(ringSizePx);
        height: v-bind(ringSizePx);
        margin: 4px;
        border: v-bind(ringBorderPx) solid var(--text-primary);
        border-radius: 50%;
        animation: lds-ring 0.8s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: var(--text-primary) transparent transparent transparent;
        /* border-color: var(--text-primary) ; */
    }
    .lds-ring div:nth-child(1) {
        animation-delay: -0.2s;
    }
    .lds-ring div:nth-child(2) {
        animation-delay: -0.1s;
    }
    .lds-ring div:nth-child(3) {
        animation-delay: -0.05s;
    }
    @keyframes lds-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>
